import { useMemo } from "react";
import { Navigate, useParams } from "react-router-dom";

import AnalysisDatePage from "@/pages/app/analysis-date";
import StateResults from "@/pages/app/state-results";

const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;

export default function AnalysisSlugRouter() {
  const { slug } = useParams();

  const resolution = useMemo(() => {
    if (!slug) {
      return { type: "redirect" };
    }

    if (slug === "today") {
      return { type: "today" };
    }

    if (DATE_REGEX.test(slug)) {
      return { type: "date" };
    }

    return { type: "state" };
  }, [slug]);

  if (resolution.type === "redirect") {
    console.warn("[AnalysisSlugRouter] Missing slug param, redirecting");
    return <Navigate to="/analysis" replace />;
  }

  if (resolution.type === "today") {
    console.warn(
      "[AnalysisSlugRouter] Received /analysis/today on slug route, redirecting",
    );
    return <Navigate to="/analysis/today" replace />;
  }

  if (resolution.type === "date") {
    console.log("[AnalysisSlugRouter] Rendering date page for", slug);
    return <AnalysisDatePage />;
  }

  console.log("[AnalysisSlugRouter] Rendering state page for", slug);
  return <StateResults />;
}

